import React from 'react';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';
import { PageRestrictionsContextProvider } from '@confluence/page-restrictions-context/entry-points/PageRestrictionsContext.ts';
import { RestrictionsDialogTriggerWrapper } from '@confluence/restrictions/entry-points/RestrictionsDialogTrigger.ts';
import { expVal } from '@confluence/feature-experiments';

type ShareAndRestrictButtonOptions = {
	isNotifyDisabled?: boolean;
};

type ContentRestrictionsTriggerProps = {
	contentId: string;
	renderShareAndRestrictButton: (opts?: ShareAndRestrictButtonOptions) => React.JSX.Element;
};

// CCPERMS-5170 / confluence_frontend_deprecate_restrictions_dialog: experiment gate. When this
// graduates, delete this whole file and render `renderShareAndRestrictButton()` directly from
// the `contentRestrictions` item in useHeaderItems.
export const ContentRestrictionsTrigger = ({
	contentId,
	renderShareAndRestrictButton,
}: ContentRestrictionsTriggerProps): React.JSX.Element => {
	if (expVal('confluence_frontend_deprecate_restrictions_dialog', 'isEnabled', false)) {
		return renderShareAndRestrictButton({ isNotifyDisabled: true });
	}

	// --- Control cohort (legacy restrictions dialog) — delete on experiment graduation ---
	return (
		<PageRestrictionsContextProvider contentId={contentId}>
			<ErrorBoundary attribution={Attribution.PERMISSIONS_EXPERIENCE}>
				<RestrictionsDialogTriggerWrapper
					contentId={contentId}
					key="restrictions-dialog-trigger"
					triggeredFrom="fromContentType"
				/>
			</ErrorBoundary>
		</PageRestrictionsContextProvider>
	);
};
